import React, { Component } from 'react';
import AddEmployeeRelateConfigPage from './add-employee-relate-config-html';
class AddEmployeeRelateConfig extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <AddEmployeeRelateConfigPage
                />
            </div>
        )
    }
}
export default AddEmployeeRelateConfig;